<template>
    <a-modal title="申报" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="100%" height="100%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="8">
                    <a-form-item label="财政年月" name="fiscalYearMonth">
                        <YearPicker style="width: 100%" v-model:value="form.fiscalYearMonth" :format="dateFormat.DATE_YEAR"
          :showTime="false" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="总资产(万元)" name="totalAssets">
                        <a-input-number style="width:100%" v-model:value="form.totalAssets" placeholder="请输入总资产(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="总负债(万元)" name="totalLiability">
                        <a-input-number style="width:100%" v-model:value="form.totalLiability" placeholder="请输入总负债(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="营业收入(万元)" name="operatingIncome">
                        <a-input-number style="width:100%" v-model:value="form.operatingIncome" placeholder="请输入营业收入(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="净利润(万元)" name="retainedProfits">
                        <a-input-number style="width:100%" v-model:value="form.retainedProfits" placeholder="请输入净利润(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="缴税总额" name="totalTax">
                        <a-input-number style="width:100%" v-model:value="form.totalTax" placeholder="请输入缴税总额" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeCompanyInfo} from "@/api/finance";
import {innovation,dateFormat} from "@/config/variableConfig";
import YearPicker from "@/components/form/datePicker/YearPicker";

export default {
    name: "合作单位信息",
    components: {YearPicker},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            dateFormat,
            form: {
                    id: null,
                    fiscalYearMonth: null,
                    totalAssets: null,
                    totalLiability: null,
                    operatingIncome: null,
                    retainedProfits: null,
                    totalTax: null
            },
            rules: {
                    id: [],
                    fiscalYearMonth: [],
                    totalAssets: [dataCheck.required({type:"number"})],
                    totalLiability: [dataCheck.required({type:"number"})],
                    operatingIncome: [dataCheck.required({type:"number"})],
                    retainedProfits: [dataCheck.required({type:"number"})],
                    totalTax: [dataCheck.required({type:"number"})]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeCompanyInfo.edit
                } else {
                    return financeCompanyInfo.add
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
